import _ from 'lodash';
export default {
    model: {
        prop: 'vModelParam',
        event: 'change'
    },
    props: {
        vModelParam: {
            type: Array
        }
    },
    watch: {
        // 监听当前值变化，及时提交给父组件
        vModelParam:{
            deep: true,
            immediate: true,
            handler: function (newValue) {
                console.log('监听到数组入参',JSON.stringify(newValue),JSON.stringify(this.localValue));
                let newValueFmt;
                if(newValue===undefined) {
                    newValueFmt = []
                }
                else {
                    newValueFmt=newValue
                }
                if(!_.isEqual(newValue,this.localValue)) {
                    console.log('将入参赋值给数组组件localValue',JSON.stringify(newValueFmt),JSON.stringify(this.localValue));
                    this.localValue = newValueFmt;
                }
            }
        },
        localValue: {
            deep: true,
            immediate: true,
            handler: function (newValue) {
                console.log('数组组件的localValue发生变化，emit change事件！')
                this.$emit('change', newValue)
            }
        },

    },
    data () {
        return {
            localValue: []
        }
    }
}